module.exports = __webpack_public_path__ + "static/img/white_logo.7ec357b9.png";